const today = new Date().getDay();
const adjustedDay = today === 0 ? 6 : today - 1;

document.querySelectorAll('.js-opening').forEach(opening => {
    const listItems = opening.querySelectorAll('li');
    if (listItems.length > adjustedDay) {
        listItems[adjustedDay].classList.add('is-active');
    }
});
